import { React } from 'react';
import StyleButton from './StyleButton';

const INLINE_STYLES = [
    { label: 'Bold', style: 'BOLD', icon: 'b' },
    { label: 'Italic', style: 'ITALIC', icon: 'i' },
    { label: 'Underline', style: 'UNDERLINE', icon: 'underline' }
];

const InlineStyleControls = ({ onToggle, editorState }) => {
    const currentStyle = editorState.getCurrentInlineStyle();

    return (
        <div>
            {INLINE_STYLES.map(type => {
                return (
                    <StyleButton
                        key={type.label}
                        active={currentStyle.has(type.style)}
                        label={type.label}
                        onToggle={onToggle}
                        style={type.style}
                        icon={type.icon}
                    />
                );
            })}
        </div>
    );
};

export default InlineStyleControls;
